import React from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';

export const MessageValue = ({ label = '' }) => (
  <div className="calendar-meeting-folder-section-value">
    <Row>
      <Col xs="12" sm="12" lg="12" className="label">
        {label}
      </Col>
    </Row>
  </div>
);

MessageValue.propTypes = {
  label: PropTypes.string,
};

MessageValue.defaultProps = {
  label: '',
};
